// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"52431f51","500":"3c1cb64b","537":"c9141315","620":"920313a5","789":"5bc0e18e"}[chunkId] + ".chunk.js";
};